import api from "./axios";

export const getCurrentWhatsAppConnection = () =>
  api.get("/whatsapp/connections/current");

export const createWhatsAppConnection = () =>
  api.post("/whatsapp/connections");

export const getWhatsAppConnectionStatus = (connectionId) =>
  api.get(`/whatsapp/connections/${connectionId}/status`);

export const getWhatsAppConnectionQR = (connectionId) =>
  api.get(`/whatsapp/connections/${connectionId}/qr`);

export const reconnectWhatsAppConnection = (connectionId) =>
  api.post(`/whatsapp/connections/${connectionId}/reconnect`);

export const disconnectWhatsAppConnection = (connectionId, logout = true) =>
  api.post(`/whatsapp/connections/${connectionId}/disconnect`, { logout });

export const getWhatsAppAISettings = () =>
  api.get("/whatsapp/ai-settings");

export const updateWhatsAppAISettings = (enabled) =>
  api.patch("/whatsapp/ai-settings", { enabled });

export const addWhatsAppAIExcludedNumber = (phone, label = null) =>
  api.post("/whatsapp/ai-settings/excluded-numbers", { phone, label });

export const removeWhatsAppAIExcludedNumber = (publicId) =>
  api.delete(`/whatsapp/ai-settings/excluded-numbers/${publicId}`);
